<template>
  <section class="primaryInfo">
    <a
      name="home"
      style=" position: relative;top: -420px;display: block;height: 0;overflow: hidden;"
    ></a>
    <section class="information">
      <NavCrumbs :crumbProp="crumbProp" v-show="isPc"></NavCrumbs>
      <section class="innerBox">
        <div class="leftMenu">
          <li
            @click="gotoHandle(leftItem.anchorId)"
            :class="[
              'menu-item',
              isActive === leftItem.anchorId ? 'menu-item--active' : ''
            ]"
            v-for="(leftItem, idx) in leftMenus"
            :key="idx"
          >
            {{ leftItem.title }}
          </li>
        </div>
        <div class="info">
            <ul class="crumbs_container">
                <li
                class="crumbs_item"
                v-for="(routeItem, routeIdx) in crumbsList"
                :key="routeIdx"
                @click="gotoHandle(routeItem.routeName)"
                >
                {{ routeItem.label }}
                <span v-if="routeIdx < crumbsList.length - 1">></span>
                </li>
            </ul>
            <p class="prevTips">
            You are currently viewing an archived version of the Terms of use.
            View the<a href="/terms"> current version</a> or
            <a href="/archivedterms">all past versions</a>.
          </p>
                    <h1>ToTok Terms of Use</h1>
                    <h3>Last Updated: August 2021 <a href="/archivedterms">{{archivedVersionLabel}}</a></h3>
                    <p>
                        <strong>
                            Please read these Terms of Use carefully
                        </strong>
                    </p>
                    <br>
                    <p>
                        <strong>ToTok Technology Limited</strong> (<strong>"Totok"</strong>, <strong>"totok"</strong>,
                        <strong>"we"</strong>, <strong>"us"</strong>
                        or <strong>"our"</strong>) provides a variety of services to customers around the world 
                        including our messaging application ToTok
                         (the <strong>"App"</strong>, or together with the other services, the
                        <strong>"Services"</strong>). Please read these Terms of Use (the <strong>"Terms"</strong> ) so you properly understand how you’re expected to use our Services 
                        and the rights you have in relation to them. By installing, accessing, 
                        downloading or otherwise using the Services, or any of their features, 
                        you are agreeing to comply with these Terms. Any reference throughout to "you", 
                        or a correlative subject, 
                        refers to the device owner and/or user of the Services.
                    </p>
                    <p>If we make any changes to these Terms, 
                        we will post the updated Terms on our website and, 
                        if these are material updates, either notify you 
                        by email to the email address specified in your account 
                        or an in-App alert the first time you use the App after
                         we make the change. You are responsible for ensuring we 
                         have an up-to-date active and deliverable email address for 
                         you and for periodically visiting these Terms to check for any 
                         changes. Your continued use of the Services will be deemed acceptance 
                         of the updated Terms. If you do not accept the updated Terms, 
                         you are no longer permitted to use the Services and should disable your account immediately.
                    </p>
                    <p>Please note that we have prepared specific terms and conditions which govern ToTok Game and, 
                        if you are located in the United Arab Emirates, PayBy and all related products 
                        and services which may be available to you via the App. Should you wish to access 
                        and review these terms and conditions, please see the
                        <a href="https://totok.ai/totok-game-terms">ToTokGame Terms of Use</a> and <a href="https://www.payby.com/terms-of-use">PayBy Terms of Use.</a>
                    </p>
                    <h2>
                        Contact
                    </h2>
                    <p>
                        Should you wish to contact us regarding the Services for any reason, 
                        including to submit a comment or complaint, please email us at: <a href="mailto:help@totok.ai">help@totok.ai</a>
                         or contact us via the App.
                    <h2>
                        Language
                    </h2>
                    <p>
                        These Terms were prepared in English and therefore the default language is English. 
                        Should you wish to access these Terms in a different language, 
                        please update the language setting on the Service being used (for example via the settings on the App) to the preferred language. 
                        Please note that not all languages are available and should there be any discrepancies or differing interpretations or meanings 
                        between the English version of these Terms and any translation, 
                        the English Terms shall prevail.
                    </p>
                    <h2>
                        Download and Registration
                    </h2>
                    <p>
                        By installing, accessing, downloading or otherwise using the Services, 
                        or any of their features, you agree to comply with the Terms and enter 
                        into a binding contract with us. Your use of the Services, including 
                        all rights you with respect to the Services, are detailed in these Terms. 
                        If you breach or violate any of the Terms, we have the right to disable 
                        your account immediately and you will not be permitted to create another 
                        account without our permission.
                    </p>
                    <p>
                        If using the App, once downloaded, you must register to use the App using the current 
                        mobile number you use and a username. In doing so, you agree to receive 
                        text messages and phone calls from us which will be sent to assist with verifying 
                        your identity and device. If you change your mobile number, you need to notify us 
                        via the App or you will not be able to operate the App using the new number.
                    </p>
                    <h2>
                        Your Personal Data
                    </h2>
                    <p>
                        Providing you with the Services requires that we collect, store, use, 
                        share and otherwise process your personal data. 
                        To learn what kinds of personal data we process along with why, how and where we process it, 
                        please read our <a href="https://totok.ai/privacy">
                        Privacy Policy</a>. It will also provide useful information about the rights you may have in relation to 
                        your personal data and how you may be able to exercise such rights.
                    </p>
                    <h2>
                        General Conditions
                    </h2>
                    <p>
                        In addition to any other conditions included in these Terms which you must comply with, please also be aware of the following:
                    </p>
                    <ul>
                        <li><strong>Age</strong>: you must be at least 13 years of age to use the Services. 
                        This age is subject to the laws of the country you are from and therefore may be higher (but never lower) than our required age. 
                        You may also be required to seek the consent of your parent or guardian to download, register or otherwise use the Services.
                        </li>
                        <li>
                            <strong>Law</strong>: you must comply with the law and not be prohibited from using the Services 
                            in any way due to the local laws or any criminal conviction you may have.
                        </li>
                        <li><strong>Disabled Account</strong>: you must not download or otherwise use the Services if any account of yours with any Service
                         (or any other service or application of a ToTok group company) has been disabled in the past.
                        </li>
                        <li><strong>Operating System</strong>: the App requires your device to be operating with at least version iOS 9 
                        (for Apple devices) and Android 5 (for Android devices) with a minimum of 200 MB of memory.
                        </li>
                        <li><strong>Device Fees</strong>: you are wholly responsible for all carrier data plan and other applicable fees and taxes associated with 
                        your use of the Services.
                        </li>
                        <li><strong>Account Security</strong>: you are responsible for keeping your device, your account and any security codes/passwords 
                        (if requested) safe and secure. 
                        If your account has been hacked, compromised or breached in any way, 
                        please contact us immediately at <a href="mailto:help@totok.ai">help@totok.ai</a> or via the App.
                        </li>
                    </ul>
                    <h2>
                        Acceptable Use
                    </h2>
                    <p>
                        When using the Services, you must always do so for legal, 
                        authorised and acceptable purposes. When using the Services, you will not, 
                        nor permit any person using your account to:
                    </p>
                    <ul>
                        <li>
                            use them in any unlawful manner, for any unlawful purpose, 
                            or in any manner inconsistent with or contravening these Terms;
                        </li>
                        <li>
                            violate or infringe the rights of ToTok, any of its group companies, our users, 
                            or other third parties, including rights in respect of privacy, 
                            intellectual property, or other proprietary rights;
                        </li>
                        <li>transmit any material that is illegal, obscene, defamatory, threatening, 
                            intimidating, harassing, hateful, racially or ethnically offensive, 
                            or which could instigate or encourage conduct that would be illegal or otherwise inappropriate, 
                            including promoting violent crimes;
                        </li>
                        <li>
                            impersonate someone;
                        </li>
                        <li>send, or be involved in sending, illegal communications;
                        </li>
                        <li>
                            seek to harm ToTok, our group companies, or any of our users or customers; or
                        </li>
                        <li>
                            access, use, copy, modify, distribute, display, 
                            otherwise exploit or prepare derivative works based upon and of our Services in impermissible or unauthorised manners, 
                            or in ways that harm us, our group companies, our Services, systems, users, or others. 
                            In particular you must not, nor permit any person using your account to:
                            <ul>
                                <li>
                                    reverse engineer, alter, modify, create derivative works from, decompile, 
                                    or extract code from our Services, except to the extent permitted by law;
                                </li>
                                <li>
                                    send, store, or transmit viruses or other harmful computer code through or onto our Services;
                                </li>
                                <li>
                                    gain or attempt to gain unauthorised access to our systems or those of our group companies;
                                </li>
                                <li>
                                    create accounts for our Services through unauthorised means;
                                </li>
                                <li>
                                    collect the information of or about our users in any impermissible 
                                    or unauthorised manner; and/or
                                </li>
                                <li>
                                    sell, resell, rent, or charge for the use of, our Services.
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <h2>
                        Device Data, Functions and Access
                    </h2>
                    <p>To operate the App efficiently and to the best of its potential ability and functionality, 
                        we require access to the following data and functions on your device:</p>
                    <ul>
                        <li>
                            network (cellular data and WiFi);
                        </li>
                        <li>
                            phone book and contacts;
                        </li>
                        <li>
                            photos, images and videos;
                        </li>
                        <li>
                            camera;
                        </li>
                        <li>
                            documents;
                        </li>
                        <li>
                            location data;
                        </li>
                        <li>
                            microphone;
                        </li>
                        <li>
                            calendar; and
                        </li>
                        <li>
                            storage.
                        </li>
                    </ul>
                    <p>
                        We will however ask your consent before accessing each such data set and 
                        function on your device. If you provide your consent with respect to a data 
                        set or function, we will remember this and not ask you again with respect to 
                        the same data set or function. You can withdraw your consent at any time 
                        by accessing your account in the App and/or via the settings of your device.
                    </p>
                    <h2>Licences and Intellectual Property</h2>
                    <ul>
                        <li>What we own:</li>
                        <p>Throughout our relationship with you, you retain ownership of the details, information or other data you submit for your account or through the use of our Services, subject to Section 8.3 below. You also have the right to grant the rights and licences in these Terms as further detailed below.
                        </p>
                        <li>
                            What you own:
                        </li>
                        <p>
                            Throughout our relationship with you, you retain ownership of the details, 
                            information or other data you submit for your account or through the use of our Services. 
                            You also have the right to grant the rights and licences in these Terms as further detailed below.
                        </p>
                        <li>
                            Licence to us
                        </li>
                        <p>
                            In order for us to provide our Services to you to the best of our ability, 
                            you grant ToTok a worldwide, royalty-free, sublicensable, 
                            and transferable license to use, reproduce, distribute, 
                            create derivative works of, and display the information (including any content) that you upload, 
                            store, send, or receive on or through the use of the Services. 
                            including account data as explained in our <a href="https://totok.ai/privacy">Privacy Policy</a>. 
                            We will use such rights for the purpose of providing our Services which includes, 
                            for example, to allow us to display your profile picture, to send your messages, 
                            and if you elect to follow official accounts on our platform, to share your nickname, 
                            your profile photo and messages sent to such official account
                        </p>
                        <li>
                            Licence to you:
                        </li>
                        <p>
                            In order for you to receive the Services at the best standard, 
                            we grant you a revocable, non-exclusive, non-sublicenseable and non-transferable licence to use the Services for the sole purpose for which they were created, 
                            subject to and in accordance with these Terms. No other licences or rights are granted to you by implication or otherwise.
                        </p>
                        <li>
                            Infringement of Intellectual Property
                        </li>
                        <p>
                            If you believe our Intellectual Property is being infringed by a third party, 
                            please contact us immediately using the contact details provided above. 
                            If we believe you are infringing our Intellectual Property or the intellectual property of another, 
                            we may terminate your account with immediate effect.
                        </p>
                    </ul>
                    
                        <h2>Updates</h2>
                        <p>
                            When an update of the App becomes available, you are strongly encouraged to download this as soon as possible
                             following its release. Updates may include upgrades, bug fixes, other error corrections, improved App security,
                              and/or new features. Updates may also modify or delete in their entirety certain features and functionality. 
                              You agree that we have no obligation to provide any updates or to continue to provide or enable any particular 
                              features or functionality. If you do not update the App, it may no longer be supported by us and, over time, 
                              will likely depreciate in functionality, and you may expose your device to vulnerabilities that updates would 
                              otherwise address. You agree that all updates will be deemed part of the App and be subject to all terms and 
                              conditions of these Terms.
                        </p>
                        <h2>
                            Support
                        </h2>
                        <p>
                            If you require support in relation to your use of the Services, 
                            please contact us at <a href="mailto:help@totok.ai">help@totok.ai</a> or via the App.
                        </p>
                        <h2>Disclaimer</h2>
                        <p>
                            You use and accept the provision of the Services at your own risk and at all times subject 
                            to the following disclaimers:
                        </p>
                        <ul>
                            <li>
                                the Services are provided on an "as is" basis without any express or implied warranties;
                            </li>
                            <li>
                                no warranty is given that any information provided by us is accurate, 
                                complete, or useful, that the Services will be operational, 
                                free from errors, secure, safe, 
                                or that the Services will function without disruptions, delays or imperfections;
                            </li>
                            <li>
                                we do not control, and are not responsible for controlling, 
                                how or when our users use our Services; and
                            </li>
                            <li>
                                you acknowledge and agree that the App may display, include, or make available third-party
                                 content (including data, information, applications, and other products, services, and/or materials, 
                                 or content provided by other users) or provide links to third-party websites or services, including 
                                 through third-party advertising ("<strong>Third-Party Materials</strong>") and you agree that: we are not responsible 
                                 for Third-Party Materials including their accuracy, completeness, timeliness, validity, copyright compliance, 
                                 legality, decency, quality, or any other aspect thereof; we do not assume and will not have any liability 
                                 or responsibility to you or any other person or entity for any Third-Party Materials; that Third-Party Materials 
                                 and links thereto are provided solely as a convenience to you, and you access and use them entirely at your own 
                                 risk and subject to such third parties’ terms and conditions; and we are not obligated to control the actions or 
                                 information (including content) of our users or other third parties.
                            </li>
                            <li>
                                The forgoing disclaimers will apply to the fullest extent permitted by applicable law.
                            </li>
                        </ul>
                    </ul>
                    <h2>
                        Our Liability
                    </h2>
                    <h6>
                        Limitation of Liability
                    </h6>
                    <p>
                        We, our affiliates, subsidiaries, officers, directors, employees, partners, agents, 
                        successors and assigns (together the "ToTok Group") will not be held liable to you, 
                         whether in contract (including under any indemnity), 
                         tort (including negligence), under statute or otherwise, 
                         under or in connection with these Terms, your use of the Services, 
                         and/or our provision of the Services, for any consequential, indirect, 
                         special or incidental losses or damages, or for any loss or damage to the extent that 
                         such loss or damage is caused or contributed to by you, or is a result of the failure 
                         by you to comply with these Terms.
                    </p>
                    <p>
                        For any other losses or damages, 
                        the ToTok Group’s aggregate liability towards you for all claims during our relationship 
                        with you shall not exceed $100 USD.
                    </p>
                    <p>
                        The forgoing exclusion and cap of liability will each apply to 
                        the fullest extent permitted by applicable law.
                    </p>
                    <h2>
                        Your Liability
                    </h2>
                    <p>
                        To the extent permitted by law, 
                        you agree to defend, indemnify, 
                        and hold harmless the ToTok Group from and against all liabilities, damages, losses, 
                        and costs (including reasonable legal fees and costs) relating to, arising out of, 
                        or in any way in connection with any of the following: (a) your access to or use of our Services; 
                        (b) your breach of our Terms; or (c) any misrepresentation made by you.
                    </p>
                    <h2>Termination</h2>
                    <h6>
                        Our right
                    </h6>
                    <p>
                        We retain the right at any time to disable your account (either indefinitely or for a set period of time) and/or terminate 
                        your access and use of any or all of the Services (including any services of our group companies) for any reason, 
                        including your violation of these Terms.
                    </p>
                    <p>
                        If your account is completely inactive for a period of six (6) months, we reserve the right to 
                        delete your account at any time and permanently delete all your messages (including all 
                        photos and videos and other content), your account information, your contacts and any other 
                        data we hold relating to you and your account within three days of us deleting your account. 
                        Once we delete your account, it cannot be reactivated.
                    </p>
                    <h6>
                        Your right
                    </h6>
                    <p>
                        You can terminate your access to any or all of our Services at any time by simply deleting your account(s).
                         If you choose to delete your App account, we will permanently delete all your messages 
                         (including all photos and videos and other content), your account information, 
                         your contacts and any other data we hold relating to you and your account within 
                         three days. Once we delete your account, it cannot be reactivated. 
                    </p>
                    <h6>Continuing provisions</h6>
                    <p>
                        However caused, 
                        the following provisions will survive any termination of your relationship with us: 
                        Licenses, Disclaimer, Our Liability, Your Liability, Termination, General and Governing Law.
                    </p>
                    <h2>General</h2>
                    <p>
                        In addition to any other terms and conditions within these Terms, 
                        please be aware of the following:
                    </p>
                    <li>
                        Entire Agreement: these Terms, the PayBy Terms of Use, the ToTok Game Terms of Use and the Privacy Policy make up the entire agreement between you and ToTok regarding your use of the Services.
                    </li>
                    <li>
                        Local Law Violations: our Services should not be accessed 
                        or otherwise used in any jurisdiction where any or all of 
                        the Services are prohibited to any degree.
                    </li>
                    <li>
                        Applicable Law: you agree to comply with all laws that apply to you in your 
                        use of the Services.
                    </li>
                    <li>
                        Wavier: any waiver of any Terms or obligations or rights hereunder 
                        is not permitted without our written consent.
                    </li>
                    <li>
                        Assignment: we may assign or otherwise transfer all or some of our rights 
                        and obligations under these Terms to another party. 
                        You may assign or otherwise transfer all or some of 
                        our rights and obligations under these Terms to another 
                        party with our prior written consent.
                    </li>
                    <li>
                        Third Parties: except as stated or contemplated herein, 
                        these Terms do not give any third party any rights.
                    </li>
                    <li>
                        Severance: if any provision of these Terms is deemed illegal, 
                        unlawful, void, or for any reason unenforceable, 
                        then that provision shall be deemed severable from our Terms and shall not affect the validity 
                        and enforceability of the remaining provisions.
                    </li>
                    <h2>
                        Governing Law
                    </h2>
                    <p>
                        We try to provide clear rules so that we can limit or hopefully avoid 
                        disputes between you and us. If a dispute does arise, however, 
                        please see the following as to how it can be resolved and what laws will apply.
                    </p>
                    <p>
                        If you are a consumer and habitually reside in a Member State of the European Union, 
                        the laws of that Member State will apply to any claim, cause of action or dispute that 
                        you have against us, which arises out of or relates to these Terms or the Services ("Claim"), 
                        and you may resolve your Claim in any competent court in that Member State that has jurisdiction 
                        over the Claim. In all other cases, you agree that the claim must be resolved in a competent 
                        court in England and that English law will govern these Terms and any claim, without regard to 
                        conflict of law provisions.
                    </p>
                </div>
        <!-- <div class="cp">All rights reserved, 2020 © Totok Pte. Ltd.</div> -->
      </section>
    </section>
    <Footer></Footer>
    <FootBanner ></FootBanner>
  </section>
</template>

<script>
import NavCrumbs from "@/components/NavCrumbs.vue";
import Footer from "@/components/Footer.vue";
import FootBanner from "@/components/FootBanner.vue";
export default {
  metaInfo() {
    return {
      title: "Terms of Use - ToTok Messenger",
      meta: [
        { property: "og:title", content: "Terms of Use - ToTok Messenger" },
        {
          property: "og:description",
          content:
            "ToTok provide you service with serious procedures and commitment"
        },
        { property: "og:url", content: "https://totok.ai/terms" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://static.totok.ai/pic/preview/free_unblocked_call.png"
        },
        { property: "og:site_name", content: "ToTok" }
      ]
    };
  },
  components: {
    NavCrumbs,
    Footer,
    FootBanner
  },
  data() {
    return {
      crumbProp: {
        label: "Privacy & Terms",
        type: "simple"
      },
      archivedVersionLabel: "(archived versions)",
      showinfo: false,
      isActive: "terms",
      
      leftMenus: [
        {
          title: "Terms of Use",
          anchorId: "terms"
        },
        {
          title: "Privacy Policy",
          anchorId: "privacy"
        }
      ]
    };
  },
  computed: {
      crumbsList() { 
        return [
            {
            label: "Privacy & Terms",
            routeName: "terms",
            },
            {
            label: "Updates: Terms of use",
            routeName: "archivedterms",
            },
            {
            label: "August 2021",
            routeName: "terms-aug",
            },
        ];
    },
    info() {
      return [];
    },
    isPc() {
      return document.body.offsetWidth > 450;
    },isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
  },
  methods: {
    gotoHandle(palice) {
      switch (palice) {
        case "terms":
          this.isActive = "terms";
          this.$router.push("terms");
          // this.mainPannel.scrollTo(0, 0)
          break;
        case "privacy":
          this.isActive = "privacy";
          this.$router.push("privacy");
          // this.mainPannel.scrollTo(0, 2000)
          break;
      }
    }
  }
};
</script>
<style scoped lang="stylus">
@media only screen and (max-width: 700px) {
    .innerBox {
        padding-bottom:60px;
    }
    .primaryInfo {
        padding: 0.8rem 0px;
        background: #fafafa;
        height: 82vh;

        .leftMenu {
            display none
        }

        div {
            margin-left: 20px;
            margin-right: 20px;
        }

        .info {

        div {
            margin-left: 20px;
            margin-right: 20px;
        }

            h1 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                padding-top: 40px;
                margin: 0px;
            }

            h2 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: 400;
                color: #808080;
                padding-bottom: 20px;
                margin: 0;
            }

            h6 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-style: italic;
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            p {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }
             .crumbs_container{
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                list-style: none;
                margin-left: 0px;
                padding-top: 20px;
                .crumbs_item{
                    color:#4377f2;
                    font-size:12px;
                    cursor pointer;
                    margin-left:10px;
                    span{
                        margin-left:10px;
                        color: #808080;
                    }
                }
                .crumbs_item:nth-child(1){
                    margin-left: 0px;
                }
                .crumbs_item:nth-last-child(1){
                    color: #808080;
                }
            }
        }
    }
    .prevTips{
                background: #e1e1e1;
                padding: 10px;
                border-radius: 4px;
            }
    .cp {
        height: 3.5rem;
        font-size: 13px;
        color: #808080;
        line-height: 3.5rem;
        text-align: center;
    }
}

@media only screen and (min-width: 701px) {
    .primaryInfo {
        padding-top: 102px;
        width: 100vw;
        background: #fafafa;

        .information {
            margin: 0 auto;
            width: 800px;

            .innerBox {
                position relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-end;
                height: 83vh;
                overflow: auto;

                .leftMenu {
                    position: absolute;
                    left: 0px;
                    top: 39px;
                    display flex;
                    flex-direction column;
                    justify-content center;
                    align-items: center;
                    list-style none;

                    .menu-item {
                        color: #979797;
                        margin-top: 30px;
                        cursor pointer;
                        text-decoration none;
                        font-size: 15px;
                    }

                    .menu-item:nth-child(1) {
                        margin-top: 0px;
                    }

                    .menu-item--active {
                        color: #000;
                        border-bottom: 2px solid #4377f2;
                    }

                }
            }
        }

        .info {
            width: 620px;
            margin: 20px 0;
            margin-bottom:40px;

            h1 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                padding-top: 20px;
                margin: 0px;
            }

            h2 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: 400;
                color: #808080;
                padding-bottom: 20px;
                margin: 0;
            }

            h6 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-style: italic;
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            p {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }
        }
    }
.prevTips{
                background: #e1e1e1;
                padding: 10px;
                border-radius: 4px;
            }
    .cp {
        height: 70px;
        font-size: 13px;
        color: #808080;
        line-height: 70px;
        text-align: center;
    }
}
</style>
